'use client'
// TODO: Xóa đi khi đã chuyển hết sang v2
import { VerifyPhone } from '@/components/auth/verify-phone'
import { toast } from '@/components/common/toast'
import { useRefreshAfterLogin } from '@/hooks/react-query/user/use-user'
import { showPopup } from '@/providers/popup-provider'
import { useRouter, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

interface VerifyTokenData {
  isset_phone: boolean
  phone: string
  user_id: string
  email: string
  service: string
  is_login: boolean
  fullname: string
}

export const VerifyProvider = ({ children }: { children: React.ReactNode }) => {
  const searchParams = useSearchParams()
  const router = useRouter()
  const refreshAfterLogin = useRefreshAfterLogin()

  const processAfterLoginSuccess = async () => {
    try {
      refreshAfterLogin()

      toast.message({
        title: 'Đăng nhập thành công',
        message: ' Mời bạn trải nghiệm mua sắm thời trang tại Coolmate.',
      })

      // Remove verify_token from URL
      const newSearchParams = new URLSearchParams(searchParams)
      newSearchParams.delete('verify_token')

      const newUrl = newSearchParams.toString()
        ? `${window.location.pathname}?${newSearchParams.toString()}`
        : window.location.pathname

      router.replace(newUrl)
      setTimeout(() => router.refresh(), 100)
    } catch (error) {
      console.error('Error in processAfterLoginSuccess:', error)
    }
  }

  useEffect(() => {
    const verifyToken = searchParams.get('verify_token')

    if (!verifyToken) return

    try {
      // Decode the base64 encoded token
      const decryptedData: VerifyTokenData = JSON.parse(atob(verifyToken))

      // Check if phone is not set, then show verify phone popup
      if (!decryptedData.isset_phone) {
        showPopup(
          <VerifyPhone
            user={{
              fullname: decryptedData.fullname || '',
              email: decryptedData.email || '',
              id: decryptedData.user_id || '',
            }}
            isConfirm={decryptedData.is_login}
            onSuccess={processAfterLoginSuccess}
          />
        )
      } else {
        // If phone is already verified, just process login success
        processAfterLoginSuccess()
      }
    } catch (error) {
      console.error('Error decoding verify_token:', error)
      toast.message({
        title: 'Lỗi xác thực',
        message: 'Token xác thực không hợp lệ.',
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, router, refreshAfterLogin])

  return <>{children}</>
}
